<template>
  <span :title="name">
    {{ name.length > maxLength ? `${name.slice(0, maxLength)}...` : name }}
  </span>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: '',
      required: true,
    },
    maxLength: {
      type: Number,
      default: 31,
    },
  },
};
</script>
